import React, { lazy, Suspense } from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Layout & Provider Imports (Statisch geladen, da immer benötigt)
import BBS2Navbar from "./components/layoutStatics/BBS2Navbar";
import Footer from "./components/layoutStatics/Footer";
import ScrollToTop from "./components/ui/ScrollToTop";
import { CartProvider } from "./components/cart/CartContext";
import CookieBanner from "./components/layoutStatics/CookieBanner";

// Startseiten-Komponenten (Statisch geladen für ein sofortiges LCP/FCP der Startseite)
import Landing from "./components/landing/Landing";
import EducationalGoals from "./components/sections/P1-EducationalGoals/EducationalGoals";
import PartnerLogos from "./components/sections/Filler/PartnerLogos";
import FinalCTA from "./components/sections/Filler/FinalCTA";

// Styles
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// DYNAMISCHE IMPORTS (Lazy Loading für alle Unterseiten & Module)
const DepartmentGrid = lazy(() => import("./components/sections/P2-DepartmentGrid/DepartmentGrid"));
const EducationForm = lazy(() => import("./components/sections/P3-EducationForm/EducationForm"));
const Imprint = lazy(() => import("./components/pages/Imprint"));
const DataProtection = lazy(() => import("./components/pages/DataProtection"));
const AccessibilityStatement = lazy(() => import("./components/pages/AccessibilityStatement"));
const Downloads = lazy(() => import("./components/pages/Downloads"));
const OurSchool = lazy(() => import("./components/pages/OurSchool"));
const Erasmus = lazy(() => import("./components/pages/schoollife/Erasmus"));
const Beratungsteam = lazy(() => import("./components/pages/schoollife/Beratungsteam"));
const RegionDesLernens = lazy(() => import("./components/pages/schoollife/RegionDesLernens"));
const Katharsis = lazy(() => import("./components/pages/schoollife/Katharsis"));
const Jba = lazy(() => import("./components/pages/schoollife/Jba"));
const Checkout = lazy(() => import("./components/checkout/Checkout"));
const Admin = lazy(() => import("./components/admin/AdminDashboard"));
const Chatbot = lazy(() => import("@thorstensmit/react-bot"));

const App = () => {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />

        <a href="#main-content" className="skip-link visually-hidden-focusable">
          Direkt zum Hauptinhalt springen
        </a>

        <div className="App bg-main-bbs text-gray-bbs">
          <BBS2Navbar />

          <Suspense
            fallback={
              <div className="container text-center my-5 py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Wird geladen...</span>
                </div>
              </div>
            }
          >
            <Routes>
              {/* HOME mit Phase 1 (Sofort bereit) */}
              <Route
                path="/"
                element={
                  <>
                    <Landing />
                    <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                      <EducationalGoals />
                      <PartnerLogos />
                      <FinalCTA />
                    </main>
                  </>
                }
              />

              <Route path="/socialmedia" element={<Navigate to="/" replace />} />

              {/* DYNAMISCHE UNTERSEITEN (Werden erst bei Aufruf geladen) */}
              <Route
                path="/angebot/:goalId"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <DepartmentGrid />
                  </main>
                }
              />

              <Route
                path="/angebot/:goalId/:deptId"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <EducationForm />
                  </main>
                }
              />

              {/* PAGES */}
              <Route
                path="/Imprint"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <Imprint />
                  </main>
                }
              />
              <Route
                path="/DataProtection"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <DataProtection />
                  </main>
                }
              />
              <Route
                path="/AccessibilityStatement"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <AccessibilityStatement />
                  </main>
                }
              />
              <Route
                path="/Downloads"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <Downloads />
                  </main>
                }
              />
              <Route
                path="/OurSchool"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <OurSchool />
                  </main>
                }
              />

              <Route
                path="/schoollife/erasmus"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <Erasmus />
                  </main>
                }
              />
              <Route
                path="/schoollife/beratungsteam"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <Beratungsteam />
                  </main>
                }
              />
              <Route
                path="/schoollife/RegionDesLernens"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <RegionDesLernens />
                  </main>
                }
              />
              <Route
                path="/schoollife/katharsis"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <Katharsis />
                  </main>
                }
              />
              <Route
                path="/schoollife/jba"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <Jba />
                  </main>
                }
              />

              {/* Checkout */}
              <Route
                path="/Checkout"
                element={
                  <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
                    <Checkout />
                  </main>
                }
              />

              {/* Admin */}
              <Route path="/Admin" element={<Admin />} />
            </Routes>
          </Suspense>

          <Footer />
          <CookieBanner />
        </div>

        {/* Chatbot */}
        <Suspense fallback={null}>
          <Chatbot apiEndpoint="https://chatbot.bbs2leer.de/chat" />
        </Suspense>
      </Router>
    </CartProvider>
  );
};

export default App;